import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Select, Input, Typography, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { AddsContainer } from './common';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';

import IssueObject, {
  getPriorityTagColor,
  getPriorityTagDescription,
} from 'stores/Classes/IssueObject';

const { Option } = Select;
const { Text } = Typography;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Issues({
  itemKey,
  item,
  services,
  deleteSubItem,
  changeSubItem,
  changeItemProperty,
}) {
  const contextValue = useContext(WorkOrderDetailsContext);

  const { currentCarIssues } = contextValue;

  const formatLabel = (issue) => {
    const issueObject = new IssueObject(issue);
    return (
      <>
        <Tag color={getPriorityTagColor(issue.priority)}>
          {getPriorityTagDescription(issue.priority)}
        </Tag>
        <Text>{issueObject.getName()}</Text>
      </>
    );
  };

  const handleChange = (value) => {
    const ids = value.map(String);
    const services = currentCarIssues
      .filter((d) => ids.includes(String(d.id)))
      .map((service) => {
        return {
          id_vehicle_service: service.id,
          name: service.name,
        };
      });

    changeItemProperty(itemKey, 'services', services);
  };

  const validServices = services.filter((d) => d.id_vehicle_service);

  return (
    <Row style={{ marginTop: '10px' }}>
      <Col span={23}>
        <Select
          style={{ width: '100%' }}
          onChange={handleChange}
          mode="multiple"
          {...(validServices.length > 0 && {
            value: validServices.map((d) => d.id_vehicle_service),
          })}
        >
          {currentCarIssues.map((issue, index) => {
            return (
              <Option key={issue.id} value={issue.id}>
                {formatLabel(issue)}
              </Option>
            );
          })}
        </Select>
      </Col>
      <IconCol span={1}>
        <DeleteOutlined
          style={{ fontSize: '20px', color: 'red' }}
          onClick={deleteSubItem}
        />
      </IconCol>
    </Row>
  );
}

export default Issues;
